import { useCallback, useRef, useState } from 'react';

export type ModalType = 'calendar' | 'history' | 'youWon' | null;

export const useDailyRewardsModals = (initialModal: ModalType = null) => {
  const [activeModal, setActiveModal] = useState<ModalType>(initialModal);
  const previousModalRef = useRef<ModalType>(null);

  const open = useCallback((modal: ModalType) => {
    previousModalRef.current = null;
    setActiveModal(modal);
  }, []);

  const switchTo = useCallback((modal: ModalType) => {
    setActiveModal((current) => {
      previousModalRef.current = current;
      return modal;
    });
  }, []);

  const close = useCallback(() => {
    previousModalRef.current = null;
    setActiveModal(null);
  }, []);

  const goBack = useCallback(() => {
    setActiveModal(previousModalRef.current);
    previousModalRef.current = null;
  }, []);

  return {
    activeModal,
    hasPrevious: previousModalRef.current !== null,
    open,
    switchTo,
    close,
    goBack,
  };
};
